import { render, staticRenderFns } from "./EnableDisableModifierGroupModal.vue?vue&type=template&id=89c1a98c&scoped=true"
import script from "./EnableDisableModifierGroupModal.vue?vue&type=script&lang=ts"
export * from "./EnableDisableModifierGroupModal.vue?vue&type=script&lang=ts"
import style0 from "./EnableDisableModifierGroupModal.vue?vue&type=style&index=0&id=89c1a98c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c1a98c",
  null
  
)

export default component.exports